import React, { Component } from "react";

export default class EmployeeDetailItemContainer extends Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: 15,
        }}
      >
        <div>{this.props.label}</div>
        <div className="col-lg-7 col-md-5">{this.props.children}</div>
      </div>
    );
  }
}
